/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const confirmSmsBodyCodeRegExp = new RegExp('^\\d{6}$');

export const ConfirmSmsBody = zod.object({
  code: zod.string().regex(confirmSmsBodyCodeRegExp),
});

export type ConfirmSmsBody = zod.input<typeof ConfirmSmsBody>;
export type ConfirmSmsBodyOutput = zod.output<typeof ConfirmSmsBody>;
